import { useEffect, useState } from "react";

export default function Preloader() {
  const [visible, setVisible] = useState(true);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const exitTimer = setTimeout(() => setExiting(true), 1400);
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 1800);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-background-100 transition-opacity duration-500 ease-out ${
        exiting ? "opacity-0" : "opacity-100"
      }`}
      aria-hidden="true"
    >
      <div className="flex flex-col items-center text-center px-6">
        <img
          src="https://public.readdy.ai/ai/img_res/b6c0b375-bf1f-46f3-81c9-0f925e3af69d.png"
          alt="Tatiana Andrade Estomaterapeuta"
          className={`h-32 w-auto object-contain transition-all duration-700 ${
            exiting ? "scale-95 opacity-0" : "scale-100 opacity-100"
          }`}
        />

        <span className="mt-8 h-px w-16 overflow-hidden bg-primary-600/20">
          <span className="block h-full w-full origin-left animate-loading bg-primary-600" />
        </span>
      </div>
    </div>
  );
}